import { _ as _objectSpread2 } from './transitions-eb14ab1a.esm.js';
import { sizes as sizes$1 } from '@hover/blueprint-theme';

// NOTE: Chakra's styled-system implementation supports fractions/decimals for
// dimensions, however the default theme defines size presets for `1` and `0.5`
// which overrides this behavior for those two specific values. Here we're
// re-defining `1` and `0.5` to ensure consistent fraction ↔ % behavior
//
// Documentation: https://chakra-ui.com/docs/features/style-props#layout-width-and-height
// Implementation: https://github.com/chakra-ui/chakra-ui/blob/bb0356f10e14886a19072b68f9e4999c6a3bfc1d/packages/styled-system/src/utils/index.ts#L38
//
// Offending space presets: https://github.com/chakra-ui/chakra-ui/blob/bb0356f10e14886a19072b68f9e4999c6a3bfc1d/packages/theme/src/foundations/spacing.ts#L3-L4
// Which get folded into `sizes`: https://github.com/chakra-ui/chakra-ui/blob/bb0356f10e14886a19072b68f9e4999c6a3bfc1d/packages/theme/src/foundations/sizes.ts#L31
var sizes = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$1), {}, {
  1: '100%',
  0.5: '50%'
});

export { sizes as s };
